define('shoppingCartIcon/miniCart',[
    "common/formUtils",
    "common/alertMessage"
],
function (formUtils, alertMessage) {

    const miniCartSelector = ".mini-cart";
    const cartIconSelector = ".shopping-cart-icon .the-icon";
    var autoHideTimeout = 0;

    function init() {
        $(cartIconSelector).webuiPopover({
            trigger: "click",
            placement: "bottom-left",
            width: 400,
            type: "html",
            url: ".mini-cart",
            animation: "fade",
            multi: true,
            arrow: false,
            closeable: true,
            onShow: populateMiniCart
        });
    }

    function flash() {
        // I've tried this by using some of the WebuiPopover methods (https://github.com/sandywalker/webui-popover),
        // but none of them worked for changing the options on the fly, so I'm accessing the popover options
        // directly from the data object on the cart icon element.
        var options = $(cartIconSelector).data("plugin_webuiPopover").options;

        // setting the options for flashing the popover
        var pageTop = $(window).scrollTop();
        var cartIconPosition = $(cartIconSelector).offset().top + $(cartIconSelector)[0].offsetHeight;
        if (pageTop > cartIconPosition) {
            // cart icon is out of the view, offset the popover so it's visible
            options.offsetTop = pageTop - cartIconPosition;
        }
        autoHideTimeout = 3000;  // auto hide the popup 3 seconds after its content has loaded

        // showing the popover
        $(cartIconSelector).webuiPopover("show");

        // resetting the options back to default values
        options.offsetTop = 0;
    }

    function populateMiniCart() {
        spinner("show");
        var postData = {};
        formUtils.useToken(postData);

        $.ajax({
            type: "POST",
            url: "/customapi/Order/GetMiniCart",
            dataType: "json",
            data: postData,
            success: function (data) {
                if (data.status === "OK") {
                    $(miniCartSelector + " .mini-cart-content").empty().html(data.content);
                    if (data.count > 0) {
                        $(miniCartSelector + " .mini-cart-button").removeClass("d-none");
                    }
                    if (autoHideTimeout > 0) {
                        // hiding the minicart popup after a set timeout
                        setTimeout(function () {
                            $(cartIconSelector).webuiPopover("hide");
                        }, autoHideTimeout);
                        autoHideTimeout = 0;
                    }
                } else if (data.status === "ERROR") {
                    alertMessage.error(data.message);
                }
            },
            error: function (jq, status, errorThrown) {
                alertMessage.error(status + ": " + errorThrown);
            },
            complete: function () {
                spinner("hide");
            }

        });

    }

    function spinner(what) {
        if (what === "show") {
            $(miniCartSelector + " .mini-cart-content").empty();             // remove previous content
            $(miniCartSelector + " .mini-cart-button").addClass("d-none");   // hide button
            $(miniCartSelector + " .spinner").removeClass("d-none");         // show spinner
        }
        else if (what === "hide") {
            $(miniCartSelector + " .spinner").addClass("d-none");
        }

    }

    return {
        init: init,
        flash: flash
    };
});

